import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { StepHeaderEntity } from "../../../../../entities/UIEntities/Form Entities/StepHeaderEntity";
import { ListItem } from "../../../../../entities/UIEntities/ListItem";
import {
  ADD_EV_RULE_FORM_STEPS,
  INPUTS_PROPS,
} from "../../../../../enums/Enums";
import { commonActions } from "../../../../../redux/reducers/CommonReducer";
import store from "../../../../../redux/Store";
import Icons from "../../../../../resources/icons/Icons";
import Strings from "../../../../../resources/Strings";
import { convertCurrencyToSymbol } from "../../../../../utils/CommonUtils";
import {
  arrayNotEmpty,
  getErrorMessage,
  isRequired,
} from "../../../../../utils/FormUtils";
import SelectInput from "../../../Inputs/CustomInputs/SelectInput";
import TextInput from "../../../Inputs/CustomInputs/TextInput";
import classes from "../WizardForm.module.css";
import SitesSelectInput from "../../../Inputs/CustomInputs/SitesSelectInput";

const AddEVRuleStep = (props) => {
  const [errors, setErrors] = useState({});
  const userTypes = useSelector((state) => state.user?.initialState?.userTypes);
  
  // excludes sites with isBillingEnabled false from selection list
  const selectedSites = useSelector((state) => state.user.selectedSites?.filter(site => site?.isBillingEnabled));

  const [stepHeader, setStepHeader] = useState(new StepHeaderEntity(
    props.isEditMode
      ? Strings.STEPS_TITLES.EDIT_EV_RULE_MODAL_TITLE
      : Strings.STEPS_TITLES.ADD_EV_RULE_MODAL_TITLE,
    "",
    Icons.EV_RULE,
    null
  ));

  useEffect(() => {
    store.dispatch(commonActions.setSideModal({ modalHeader: stepHeader }));
  }, [stepHeader]);

  useEffect(() => {
    if (props.currentStep === ADD_EV_RULE_FORM_STEPS.ADD_EV_RULE) {
      const hasError = Object.values(errors).some((hasError) => hasError);
      props.handleCurrentStepValidity(hasError);
    }
  }, [errors]);

  if (props.currentStep !== ADD_EV_RULE_FORM_STEPS.ADD_EV_RULE) {
    return null;
  }

  const handleChange = (newProp) => {
    props.setSelectedSite(newProp?.selectedSite);
  }

  const handleError = (error) => {
    setErrors((prevState) => ({
      ...prevState,
      ...error,
    }));
  };

  const getUserTypeSelectionOptionsList = () => {
    return userTypes
    .filter((type) => type.siteId === props.selectedSite.id || type.siteId === null /* adds Transient */)
    .map((type) => new ListItem(type.id, type.type, type.id));
  };

  const handleUserTypeSelectionRender = (selected) => {
      let list = getUserTypeSelectionOptionsList();

      return selected.map((type) => {
        let selection = [];
         list?.forEach((item) => {
          if ( type === item?.value) selection.push(item?.label)  
        })
        return selection
      }).join(', ')
  };

  return (
    <div className={classes.stepContainer}>
      <div className={classes.stepTitle}>
        {Strings.STEPS_TITLES.ADD_EV_RULE_TITLE}
      </div>
      <span className={classes.stepSubTitle}>
        {Strings.STEPS_TITLES.ADD_EV_RULE_SUB_TITLE}
      </span>

      <div className={classes.fileds}>
      <SitesSelectInput
          label={Strings.INPUT_LABELS.FACILITY}
          id={INPUTS_PROPS.SELECTED_SITE}
          onChange={handleChange}
          list={selectedSites} // list={props.sitesList}
          sitesData={null} // added
          value={props.isEditMode ? props.selectedSite.id : (props.selectedSite?.id ? props.selectedSite.id : selectedSites?.length >  0 ? selectedSites[0].id : null) } 
          disabled={props.isEditMode} 
        />
        <SelectInput
          multiple={true}
          optionIcon={Icons.CHECKBOX_CIRCLE}
          label={Strings.INPUT_LABELS.BILLING_USER_TYPE}
          renderValue={handleUserTypeSelectionRender}
          list={getUserTypeSelectionOptionsList()}
          id={INPUTS_PROPS.BILLING_USER_TYPE}
          value={props.userType}
          onChange={props.handleChange}
          isStepSubmitted={props.isStepSubmitted}
          handleError={handleError}
          hasError={!arrayNotEmpty(props.userType).isValid}
          errorMessage={getErrorMessage(arrayNotEmpty(props.userType))}
        />
        <TextInput
          label={Strings.INPUT_LABELS.RULE_NAME}
          id={INPUTS_PROPS.RULE_NAME}
          value={props.ruleName}
          onChange={props.handleChange}
          isStepSubmitted={props.isStepSubmitted}
          handleError={handleError}
          hasError={!isRequired(props.ruleName).isValid}
          errorMessage={getErrorMessage(isRequired(props.ruleName))}
        />
        <TextInput
          label={Strings.INPUT_LABELS.COST_PER_KV}
          id={INPUTS_PROPS.COST_PER_KV}
          value={props.costPerKV}
          onChange={props.handleChange}
          isStepSubmitted={props.isStepSubmitted}
          handleError={handleError}
          hasError={!isRequired(props.costPerKV).isValid}
          errorMessage={getErrorMessage(isRequired(props.costPerKV))}
         //startAdornment={convertCurrencyToSymbol(selectedSite.billingCurrency)}
         startAdornment={convertCurrencyToSymbol(props.selectedSite? props.selectedSite.billingCurrency : selectedSites[0].billingCurrency)}
         type={"number"}
        />
      </div>
    </div>
  );
};

export default AddEVRuleStep;
